import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { AtnaAssistant } from '../components/collectes/AtnaAssistant';
import { AddressCard } from '../components/collectes/AddressCard';
import { CollectionTracker } from '../components/collectes/CollectionTracker';
import { CollectionList } from '../components/collectes/CollectionList';
import { ReminderPreferences } from '../components/collectes/ReminderPreferences';
import { resetLiveTruck } from '../hooks/useLiveTruck';
export function MesCollectes() {
  // Le camion repart de son point de départ à chaque ouverture du module (avant le rendu de la carte).
  useState(() => {
    resetLiveTruck();
    return null;
  });
  const [remindersOpen, setRemindersOpen] = useState(false);
  return <main className="bg-white" data-id="element-3206" data-mp="30aoxy80l263">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-3207" data-mp="7xkf5g389huz">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-3208" data-mp="7vgct2kz8qwt">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-blue" data-id="element-3209" data-mp="800mb57mgx9q">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-3210" data-mp="3v6jd8k7lbjtl" />
          <span aria-current="page" data-id="element-3211" data-mp="3v8x8ou66my1o">Mes collectes</span>
        </nav>

        <header className="mt-4" data-id="element-3212" data-mp="3q91cvi7n2cx7">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-3213" data-mp="3qa2q9tc4nbi3">
            <Link to="/mes-collectes/calendrier" className="group inline-flex items-center gap-2 rounded transition-colors duration-150 ease-ville hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-3214" data-mp="qupeera9zd7h">
              Mes collectes
              <ChevronRightIcon className="h-7 w-7 text-slate-400 transition-[transform,color] duration-150 ease-ville group-hover:translate-x-0.5 group-hover:text-ville-indigo lg:h-8 lg:w-8" aria-hidden="true" data-id="element-3215" data-mp="1aglomo6298tx" />
              <span className="sr-only" data-id="element-3216" data-mp="1omnkvcva9mco">Voir le calendrier complet</span>
            </Link>
          </h1>
          <p className="mt-3 max-w-2xl text-[17px] leading-relaxed text-slate-600" data-id="element-3217" data-mp="1tkfd67zubahe">
            Consultez vos prochaines collectes et obtenez rapidement l’information pour votre adresse.
          </p>
        </header>

        <div className="mt-8" data-id="element-3218" data-mp="1jtb1bh5go5qs">
          <AtnaAssistant data-id="element-3219" data-mp="15v37hi3q1kju" />
        </div>

        <div className="mt-6" data-id="element-3220" data-mp="15u1jye5ir5l8">
          <AddressCard data-id="element-3221" data-mp="15xz3v1zx8166" />
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[380px_minmax(0,1fr)] lg:gap-8" data-id="element-3222" data-mp="1auz9jbsuz1wr">
          <CollectionTracker remindersOpen={remindersOpen} onToggleReminders={() => setRemindersOpen(current => !current)} data-id="element-3223" data-mp="wvg1ej01rqkg" />
          <div className="flex min-w-0 flex-col" data-id="element-3224" data-mp="10ym9zxamttu3">
            <CollectionList data-id="element-3225" data-mp="2ra0kir8pze1q" />
            <AnimatePresence data-id="element-3226" data-mp="2r9qsky446wte">
              {remindersOpen && <ReminderPreferences key="reminder-preferences" onClose={() => setRemindersOpen(false)} data-id="element-3227" data-mp="2vau5pcus2eqx" />}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </main>;
}